import { createFileRoute, redirect } from '@tanstack/react-router'
import { HoldingsPage } from '../pages/HoldingsPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/holdings' as any)({
    component: HoldingsPage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})

